<template>
  <div class="page-main">
    <div class="page-l" v-if="billId">
      <b-detail-nav :id="billId" />
    </div>
    <div class="page-r">
      <!-- <b-detail-step v-if="billId" :status="detailData.formData.status" :list="stepListData" /> -->
      <div class="m-b-10">
        <el-button v-if="!isDisabledPage" type="primary" size="mini" @click="itemSave">
          保存
        </el-button>
        <el-button v-if="!billId" type="warning" size="mini" @click="itemPriceVerify">
          价格计算
        </el-button>
        <el-button
          v-if="billId && detailData.formData.status === 0"
          type="success"
          size="mini"
          @click="itemPush"
        >
          提交审核
        </el-button>
        <el-button
          v-if="
            billId &&
            detailData.formData.status === 1 &&
            $tool.hasControl(['/checkBill/leaderReject'])
          "
          type="danger"
          size="mini"
          @click="itemReject"
        >
          审核拒绝
        </el-button>
        <el-button
          v-if="
            billId &&
            detailData.formData.status === 1 &&
            $tool.hasControl(['/checkBill/leaderDoAudit'])
          "
          type="success"
          size="mini"
          @click="itemPass"
        >
          审核通过
        </el-button>
        <el-button
          v-if="billId"
          type="primary"
          size="mini"
          :disabled="$util.isBlankVue(billId)"
          @click="itemPrint"
        >
          打印
        </el-button>
        <el-button v-if="billId" type="success" size="mini" @click="itemCopy">引用新增</el-button>
        <el-button v-if="billId" type="default" size="mini" @click="jumpAdd">新增</el-button>
      </div>
      <e-form
        class="p-t-10 b-t-1"
        ref="refForm1"
        :config="formConfig"
        :column="formColumn1"
        :data.sync="detailData.formData"
        :disabled="isDisabledPage"
      />
      <div class="table-main" :style="{ height: `${this.$util.getViewHeight() - 36 - 278}px` }">
        <TableSale
          tableTitle="bom表清单"
          :parent="null"
          :data.sync="detailData.tableSaleData"
          :disabled="isDisabledPage"
          :statusName="detailData.formData.status_name"
          :categoryList="categoryList"
          :craftList="craftList"
          :textureList="textureList"
          :unitList="unitList"
        />
      </div>
      <e-form
        class="m-t-10"
        :config="formConfig"
        :column="formColumn2"
        :data.sync="detailData.formData"
        :disabled="isDisabledPage"
      />
      <div class="total-main">
        <span v-for="(item, index) in formColumn3" :key="index" class="total-item">
          <span>{{ item.title }}:</span>
          <span class="total-item-price">{{ detailData.formData[item.field] }}</span>
          <span>{{ item.suffix }}</span>
        </span>
      </div>

      <!-- 弹窗-增改客户 -->
      <b-popup-customer
        v-if="isShowPopupCustomer"
        :show.sync="isShowPopupCustomer"
        :id="activeId"
        :salerId="detailData.formData.saler_id"
        :salerName="detailData.formData.saler_name"
        :isLockJieDaiStatus="!activeId"
        @success="customerUpdate"
      />

      <!-- 弹窗 价格校验 -->
      <PopupPriceVerify v-if="isShowPopupPriceVerify" :show.sync="isShowPopupPriceVerify" />
    </div>
  </div>
</template>

<script>
import math from './math'
export default {
  components: {
    TableSale: () => import('./table-sale'),
    PopupPriceVerify: () => import('./popup-price-verify')
  },
  data() {
    return {
      isUpdatePage: false, // 是否更新过页面数据
      isPassRequired: true, // 是否通过必填
      isItemPush: false,
      isItemPrint: false,
      customerKeyword: '',
      stepListData: [
        {
          key: '提交核算单',
          val: 0,
          des: [
            {
              key: '提交人',
              val: ''
            },
            {
              key: '提交时间',
              val: ''
            }
          ]
        },
        {
          key: '销售总监审核',
          val: 1,
          des: [
            {
              key: '审核人',
              val: ''
            },
            {
              key: '审核时间',
              val: ''
            }
          ]
        },
        {
          key: '完成',
          val: 2,
          des: [
            {
              key: '完成时间',
              val: ''
            }
          ]
        }
      ],
      formConfig: {
        width: '200px'
      },
      formColumn1: [
        {
          type: 'date',
          title: '销售日期',
          field: 'bill_date',
          required: true,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'text',
          title: '销售单号',
          field: 'bill_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'select',
          title: '业务员',
          field: 'saler_id',
          options: []
        },
        {
          type: 'select',
          title: '客户',
          field: 'company_merge_str',
          hide: false,
          options: [],
          optionDo: { title: '编辑', fn: () => {} },
          emptyDo: { title: '新增客户', fn: () => {} },
          remote: true,
          remoteMethod: (val) => {
            this.customerKeyword = val
            this.getCustomerList(true)
          },
          fnChange: () => {
            this.customerChoose()
          }
        },
        {
          type: 'select',
          title: '开单公司',
          field: 'saler_company_name',
          width: '290px',
          options: this.$constant.companyList
        },
        {
          type: 'text',
          title: '单据备注',
          field: 'bill_remark'
        },
        {
          type: 'text',
          title: '修改人',
          field: 'update_name',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'date',
          title: '交货日期',
          field: 'jiao_huo_ri_qi',
          required: true,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        }
      ],
      formColumn2: [
        {
          type: 'number',
          title: '销售运费',
          field: 'freight_fees_bill',
          suffix: '元',
          fnChange: () => {
            math.totalFormData(this.detailData) // 计算-表格汇总计算
          }
        },
        {
          type: 'number',
          title: '打包费',
          field: 'pack_fees_bill',
          suffix: '元',
          fnChange: () => {
            math.totalFormData(this.detailData) // 计算-表格汇总计算
          }
        },
        {
          type: 'number',
          title: '其他费用',
          field: 'other_fees_bill',
          suffix: '元',
          fnChange: () => {
            math.totalFormData(this.detailData) // 计算-表格汇总计算
          }
        },
        {
          type: 'number',
          title: '税率',
          field: 'bill_tax_rate',
          suffix: '%',
          fnChange: () => {
            math.totalFormData(this.detailData) // 计算-表格汇总计算
          }
        },
        {
          type: 'number',
          title: '税金',
          field: 'tax_fees_total',
          suffix: '元',
          placeholder: '自动计算',
          disabled: true
        },
        {
          type: 'number',
          title: '费用合计',
          field: 'fees_total',
          suffix: '元',
          placeholder: '自动计算',
          disabled: true
        }
      ],
      formColumn3: [
        {
          title: '订单成本',
          field: 'cost_price_total',
          suffix: '元'
        },
        {
          title: '订单销售金额',
          field: 'sales_amount_total',
          suffix: '元'
        },
        {
          title: '订单利润',
          field: 'profit_total',
          suffix: '元'
        },
        {
          title: '订单利润率',
          field: 'profit_rate_total',
          suffix: '%'
        },
        {
          title: '材料成本',
          field: 'material_sales_amount_total',
          suffix: '元'
        },
        {
          title: '加工成本',
          field: 'process_price_total',
          suffix: '元'
        },
        {
          title: '提成金额',
          field: 'push_money',
          suffix: '元'
        }
      ],

      detailData: {
        formData: {
          bill_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 销售日期
          bill_code: '', // 销售单号
          saler_id: '', // 业务员id
          saler_name: '', // 业务员
          commission_rate: '', // 提成比例
          company_name: '', // 客户
          company_uuid: '', // 客户uuid
          company_merge_str: '', // 客户合并字段
          saler_company_name: this.$constant.company_info.company_name, // 开单公司
          bill_remark: '', // 单据备注
          update_name: '', // 修改人
          jiao_huo_ri_qi: '', // 销售日期
          freight_fees_bill: '', // 销售运费
          pack_fees_bill: '', // 打包费
          other_fees_bill: '', // 其他费用
          bill_tax_rate: '', // 税率
          tax_fees_total: '', // 税金
          fees_total: '', // 费用合计
          cost_price_total: '', // 订单成本
          sales_amount_total: '', // 订单销售金额
          profit_total: '', // 订单利润
          profit_rate_total: '', // 订单利润率
          material_sales_amount_total: '', // 材料成本
          process_price_total: '', // 加工成本
          push_money: '' // 提成金额
        },
        tableSaleData: []
      }, // 详情数据
      detailTimer: null, // 详情数据更新计时器

      saleList: [],
      customerList: [],
      categoryList: [],
      craftList: [],
      textureList: [],
      unitList: [],

      isShowPopupCustomer: false,
      isShowPopupPriceVerify: false,
      activeId: null
    }
  },
  computed: {
    billId() {
      return this.$route.query.id
    },
    isDisabledPage() {
      return this.billId && !!this.detailData.formData.status
    },
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  watch: {
    detailData: {
      handler(val) {
        this.isUpdatePage = true
        this.isPassRequired = true
        this.setPassRequired(val.tableSaleData)
      },
      deep: true
    },
    'detailData.tableSaleData': {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            if (this.detailTimer) {
              clearTimeout(this.detailTimer)
            }
            this.detailTimer = setTimeout(() => {
              math.totalDetailData(this.detailData) // 计算-汇总详情
              this.detailTimer = null
            }, 100)
          }
        })
      },
      deep: true
    },
    'detailData.formData.saler_id': {
      handler(newVal) {
        this.saleList.forEach((item) => {
          if (item.val === newVal) {
            this.detailData.formData.saler_name = item.key
          }
        })
      },
      deep: true
    }
  },
  mounted() {
    if (this.billId) {
      this.getDetailData()
    } else {
      this.getSaleList()
      this.detailData.formData.commission_rate = this.selfAccountData.commission_rate // 初始化-提成比例
      this.detailData.tableSaleData = [this.$util.deepCopy(this.$constant.tableSaleObj)] // 初始化-数据结构
    }

    // 初始化-新增客户
    this.formColumn1.forEach((item) => {
      if (item.field === 'company_merge_str') {
        item.optionDo.fn = this.customerEdit
        item.emptyDo.fn = this.customerAdd
      }
    })

    this.getCustomerList()
    this.getCategoryList()
    this.getCraftList()
    this.getTextureList()
    this.getUnitList()
  },
  methods: {
    // 初始化-步骤条
    initStepListData() {
      this.stepListData[0].des[0].val = this.detailData.formData.submiter // 提交人
      this.stepListData[0].des[1].val = this.detailData.formData.submit_time // 提交时间
      this.stepListData[1].des[0].val = this.detailData.formData.leader // 审核人
      this.stepListData[1].des[1].val = this.detailData.formData.leader_time // 审核时间
      this.stepListData[2].des[0].val = this.detailData.formData.finish_time // 完成时间
    },
    // 设置通过必填
    setPassRequired(data) {
      data.forEach((item) => {
        if (!(item.category && item.craft)) this.isPassRequired = false
        if (item.tableBomData.length) this.setPassRequired(item.tableBomData)
      })
    },
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/detail',
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.detailData = this.$util.deepCopy(res.data)
          let { company_name, company_uuid } = this.detailData.formData
          this.detailData.formData.company_merge_str =
            company_name && company_uuid ? `${company_name}|${company_uuid}` : ''
          this.initStepListData()
          this.getSaleList()
          setTimeout(() => {
            this.isUpdatePage = false
          }, 200)
        }
      })
    },
    // 获取业务员列表
    getSaleList() {
      this.$api({
        method: 'post',
        url: '/admin/account/getAccountList',
        data: {
          filterData: {
            role_name: '业务员'
          },
          pageSize: this.$constant.pageMax
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.nick_name,
              val: item.id
            }
          })

          // 不存在当前账户id，则增加到下拉
          let selfAccountObj = {
            key: this.selfAccountData.nick_name,
            val: this.selfAccountData.id
          }
          let isExistAccount = result.some((item) => {
            return item.val === selfAccountObj.val
          })
          if (!isExistAccount) result.unshift(selfAccountObj)

          // 不存在已选业务员，增加到下拉
          let selfOrderObj = {
            key: this.detailData.formData.saler_name,
            val: this.detailData.formData.saler_id
          }
          let isExistOrder = result.some((item) => {
            return item.val === selfOrderObj.val
          })
          if (!isExistOrder && !!selfOrderObj.val && selfAccountObj.val !== selfOrderObj.val) {
            result.unshift(selfOrderObj)
          }

          // 初始化-业务员
          this.formColumn1.forEach((item) => {
            if (item.field === 'saler_id') item.options = this.$util.deepCopy(result)
          })
          if (!this.detailData.formData.saler_id) {
            result.forEach((item) => {
              if (item.val === selfAccountObj.val) {
                this.detailData.formData.saler_name = item.key // 初始化-业务员
                this.detailData.formData.saler_id = item.val // 初始化-业务员id
              }
            })
          }

          this.saleList = result
        } else {
          return
        }
      })
    },
    // 获取客户列表
    getCustomerList(isFilter = false) {
      this.formColumn1.forEach((itemColumn) => {
        if (itemColumn.field === 'company_merge_str') {
          if (!isFilter) itemColumn.hide = true
          this.$api({
            method: 'post',
            url: '/admin/customers/search',
            data: {
              keyword: this.customerKeyword,
              pageSize: 200
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              let result = res.data.page.list.map((item) => {
                return {
                  key: item.customer_name,
                  val: `${item.customer_name}|${item.company_uuid}`,
                  id: item.id,
                  uuid: item.company_uuid
                }
              })
              this.customerList = result
              itemColumn.options = this.$util.deepCopy(this.customerList)
              if (!isFilter) itemColumn.hide = false
            }
          })
        }
      })
    },
    // 获取品类列表
    getCategoryList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/machine/list',
        data: {
          pId: '301' // 类别
        }
      }).then((res) => {
        if (res.status === 200) {
          let result = res.data.list.map((item) => {
            return {
              key: item.name,
              val: item.name
            }
          })
          this.categoryList = result
        }
      })
    },
    // 获取品名列表
    getCraftList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/stock/searchHeard',
        data: {
          heardAutoCompleteName: 'craft'
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.value,
              val: item.value
            }
          })
          this.craftList = result
        }
      })
    },
    // 获取材质列表
    getTextureList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/machine/list',
        data: {
          pId: '19' // 材质
        }
      }).then((res) => {
        if (res.status === 200) {
          let result = res.data.list.map((item) => {
            return {
              key: item.name,
              val: item.name
            }
          })
          this.textureList = result
        }
      })
    },
    // 获取单位列表
    getUnitList() {
      this.$api({
        method: 'post',
        url: '/admin/unitSetting/search'
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.name,
              val: item.name
            }
          })
          this.unitList = result
        }
      })
    },
    // 客户新增
    customerAdd() {
      let refForm1 = this.$refs.refForm1
      refForm1.$refs.company_merge_str[0].blur()
      this.activeId = null
      this.isShowPopupCustomer = true
    },
    // 客户编辑
    customerEdit(data) {
      this.activeId = data.id
      this.isShowPopupCustomer = true
    },
    // 客户更新
    customerUpdate(val) {
      this.getCustomerList()
      this.detailData.formData.company_name = val.customer_name
      this.detailData.formData.company_uuid = val.company_uuid
      this.detailData.formData.company_merge_str = `${val.customer_name}|${val.company_uuid}`
    },
    // 客户选择
    customerChoose() {
      let list = []
      if (this.detailData.formData.company_merge_str) {
        list = this.detailData.formData.company_merge_str.split('|')
      }
      if (list.length) {
        this.detailData.formData.company_name = list[0]
        this.detailData.formData.company_uuid = list[1]
      } else {
        this.detailData.formData.company_name = ''
        this.detailData.formData.company_uuid = ''
      }
    },
    // 项-保存
    itemSave() {
      if (!this.detailData.formData.bill_date) {
        this.$message.error('请选择销售日期')
        return
      }
      if (!this.detailData.formData.jiao_huo_ri_qi) {
        this.$message.error('请选择交货日期')
        return
      }
      if (!this.isPassRequired) {
        this.$message.error('商品类目和品名为必填项')
        return
      }
      this.setProcessOrderName(this.detailData.tableSaleData) // 设置工序
      this.$api({
        method: 'post',
        url: '/admin/gcvip/checkBill/saveOrUpdate',
        data: this.detailData
      }).then((res) => {
        if (res.data.state === 'ok') {
          if (this.billId) {
            if (this.isItemPush) {
              this.isItemPush = false
              this.itemPushConfirm()
              return
            }
            if (this.isItemPrint) {
              this.isItemPrint = false
              this.itemPrintConfirm()
              return
            }
            this.$message.success('保存成功')
            this.getDetailData()
          } else {
            this.$message.success('保存成功')
            this.$router.push({
              path: '/sale/verify/detail',
              query: { id: res.data.id }
            })
          }
        }
      })
    },
    // 项-价格校验
    itemPriceVerify() {
      this.isShowPopupPriceVerify = true
    },
    // 设置工序
    setProcessOrderName(list) {
      list.forEach((itemSt) => {
        itemSt.process_list.forEach((itemNd, indexNd) => {
          itemNd.process_order_name = `工序${indexNd + 1}`
        })
        if (itemSt.tableBomData.length) {
          this.setProcessOrderName(itemSt.tableBomData)
        }
      })
    },
    // 项-提交审核
    itemPush() {
      if (this.isUpdatePage) {
        this.isItemPush = true
        this.itemSave()
      } else {
        this.itemPushConfirm()
      }
    },
    // 项-提交审核-确认
    itemPushConfirm() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/salerDoAudit',
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已提交审核')
          this.getDetailData()
        }
      })
    },
    // 项-审核拒绝
    itemReject() {
      this.$confirm(
        `销售单号：${this.detailData.formData.bill_code}，该核算单是否驳回审核?`,
        '提示'
      )
        .then(() => {
          this.itemRejectConfirm()
        })
        .catch(() => {})
    },
    // 项-审核拒绝-确认
    itemRejectConfirm() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/leaderReject',
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已驳回审核')
          this.getDetailData()
        }
      })
    },
    // 项-审核通过
    itemPass() {
      this.$confirm(
        `销售单号：${this.detailData.formData.bill_code}，该核算单是否通过审核?`,
        '提示'
      )
        .then(() => {
          this.itemPassConfirm()
        })
        .catch(() => {})
    },
    // 项-审核通过-确认
    itemPassConfirm() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/leaderDoAudit',
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已通过审核')
          this.getDetailData()
        }
      })
    },
    // 项-打印
    itemPrint() {
      if (this.isUpdatePage) {
        this.isItemPrint = true
        this.itemSave()
      } else {
        this.itemPrintConfirm()
      }
    },
    // 项-打印-确认
    itemPrintConfirm() {
      window.open(`/sale/verify/print?id=${this.billId}`, '_blank')
    },
    // 项-引用新增
    itemCopy() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill/copy',
        params: {
          id: this.billId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('引用新增成功')
          setTimeout(() => {
            this.$router.push(`/sale/verify/detail?id=${res.data.id}`)
          }, 1500)
        }
      })
    },
    // 跳转-新增
    jumpAdd() {
      this.$router.push('/sale/verify/detail')
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  position: relative;
  display: flex;
  height: 100%;
  .page-l {
    margin: 0 10px 10px 0;
  }
  .page-r {
    flex: 1;
  }
  .table-main {
    border: 1px solid #e8eaec;
    overflow-y: auto;
    overflow-x: hidden;
    .scroll-bar();
  }
  .total-main {
    padding: 15px 10px 5px 10px;
    font-size: 12px;
    border-top: 1px solid #e8eaec;
    color: #606266;
    .total-item {
      margin-right: 20px;
      .total-item-price {
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;
        color: @colorRed;
      }
    }
  }
}
</style>
